import { useCallback } from 'react'
import { useLazyGetApiV1GroupsByGroupIdChannelsQuery } from '../../appsApi'
import { getGroupChannelPath } from '@wellesley/group/helpers/getGroupChannelPath'
import { User } from '@wellesley/openapi'

type UseDefaultChannelLinkProps = {
  groupId: string
  groupName: string
  defaultChannel?: User
}
export const useDefaultChannelLink = () => {
  const [getChannels] = useLazyGetApiV1GroupsByGroupIdChannelsQuery({})

  const getMainChannel = useCallback(
    async (groupId: string) => {
      const channels = await getChannels({ groupId, full: null }, true).unwrap()
      return channels?.find((channel) => channel.groupPrimary)
    },
    [getChannels],
  )

  const getDefaultChannelLink = useCallback(
    async ({
      groupId,
      groupName,
      defaultChannel,
    }: UseDefaultChannelLinkProps) => {
      const channel = defaultChannel ?? (await getMainChannel(groupId))

      if (!channel) return null

      return getGroupChannelPath({
        groupName,
        channel: { groupUserName: channel.groupUserName },
      })
    },
    [getChannels, getMainChannel],
  )

  return { getDefaultChannelLink }
}
